import { render, staticRenderFns } from "./Tjuvochpolis.vue?vue&type=template&id=28ca72c1&scoped=true&"
import script from "./Tjuvochpolis.vue?vue&type=script&lang=js&"
export * from "./Tjuvochpolis.vue?vue&type=script&lang=js&"
import style0 from "./Tjuvochpolis.vue?vue&type=style&index=0&id=28ca72c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ca72c1",
  null
  
)

export default component.exports